import { useLocation } from "react-router-dom";
import { LiquidMetal } from '@paper-design/shaders-react';

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="relative flex flex-col items-center justify-center h-screen text-center px-4">
      {/* <h1 className="absolute bottom-0 text-9xl md:text-[12rem] font-black text-white/5 select-none pointer-events-none z-0">
        404
      </h1> */}
      <div className="relative z-10 w-full max-w-[1280px] aspect-video">
        {/* <h1 className="text-xl md:text-2xl font-semibold mt-6">This page has not been generated</h1>
        <p className="mt-2 text-base text-gray-400 font-mono">{location.pathname}</p>
        <p className="mt-4 text-lg md:text-xl text-gray-500">Tell me more about this page, so I can generate it</p> */}

        <LiquidMetal
          width="100%"
          height="100%"
          image="/236.png"
          colorBack="#000000"
          colorTint="#ffffff"
          shape={undefined}
          repetition={2}
          softness={0.1}
          shiftRed={0.2}
          shiftBlue={0.2}
          distortion={0.07}
          contour={0.4}
          angle={70}
          speed={1}
          scale={0.6}
          fit="contain"
        />

      </div>
    </div>
  );
}